<!-- MFITTで引換券で取得したチケットをキャンセルする場合 -->
<template>
  <ItemDialog ref="confirmCancelMyTicket" image-type="alert">
    <template #content-area>
      <h2>チケットの取り消し</h2>
      <p class="text-center">チケットを取り消します。<br />よろしいですか?</p>
    </template>
    <template #button-area>
      <ItemButton
        label="チケット取り消し"
        action-type="btn-primary"
        @clicked="cancelMyTicket()"
      />
      <ItemButton
        label="閉じる"
        action-type="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogConfirmCancelMyTicket",
  setup(_, context) {
    const confirmCancelMyTicket = ref(null);

    const cancelMyTicket = () => {
      context.emit("cancelMyTicket");
    };

    const openDialog = () => {
      confirmCancelMyTicket.value.open();
    };

    const closeDialog = () => {
      confirmCancelMyTicket.value.close();
    };

    return {
      confirmCancelMyTicket,
      cancelMyTicket,
      openDialog,
      closeDialog,
    };
  },
};
</script>
<style scoped lang="scss">
.text-center {
  text-align: center;
}
</style>
